export const NoteStyle = {

  variants: {
    wrapper: {
      '.editableWrapper': {
        display: 'flex',
        justifyContent: 'flex-start',
      },
      '.editableTag': {
        display: 'flex',
        border: 'none',
        outline: 'none',
        fontWeight: 'normal',
      },
      '.date': {
        textDecoration: 'underline',

      },
      '.time': {
        marginLeft: '.4rem',
      },
      '.editNoteButtons': {
        margin: '0',
        display: 'flex',
      },
      '.editNoteButtonWrapper': {
        margin: '.1rem 0 0 .3rem',
      },
      '.editNoteButton': {
        cursor: 'pointer',
      },
      '.ownerWrapper': {
        height: '1.2rem',
        textAlign: 'center',
        margin: '.4rem 0 .4rem .4rem',
      },
      '.owner': {
        fontWeight: 'bold',
        backgroundColor: '#D7DDE8',
        border: '1px solid red',
        cursor: 'default',
        lineHeight: '1.2rem',
        fontSize: '.7rem',
        float:'left',
        padding:'.1rem 0 .1rem .1rem',
        borderRadius: '50%',
        width:'25px',
        height:'25px',
      },
      '.replyWrapper': {
        display: 'block',
        margin: '0 0 0 1.4rem',
        borderLeft: '1px solid #D7DDE8',
      },
      '.keyIcon': {
        display: 'inline-block',
        width: 'fit-content',
      },
      '.greenHover': {
        _hover: {
          color: 'green',
        },
      },
      '.sendEmail': {
        color: 'blue',
        textDecoration: 'underline',
      },
      '.clear': {
        textDecoration: 'line-through',
        color: 'green',
      },
      '.notClear': {
        color: 'red',
      },
    },
  },
};

